import { FC, useState } from 'react';
import { useGroupSelection } from 'utils/hooks/useGroupSelection';
import { DeleteDataByViewId } from '../types';
import { SelectionContext } from './SelectionContext';

export const SelectionContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { selected, toggleSelection, deselectAll, selectByIds } = useGroupSelection();

  /**
   * The following fields:
   * - id (used to dictate which view to delete)
   * - name (used in the UI to represent the view)
   * - createdByEmail (a view can only be deleted by its creator)
   * - isPrivate (used to determine if the public warning banner should appear)
   * are used throughout the deletion workflow.
   *
   * Since view selections should be preserved when navigating between pages,
   * upon selection, these fields are stored in deleteDataByViewId (indexed with the id as the key)
   * so that they can be easily referenced if/when the views are deleted.  Otherwise,
   * the view info would be lost upon every page change.
   */
  const [deleteDataByViewId, setDeleteDataByViewId] = useState<DeleteDataByViewId>({});

  return (
    <SelectionContext.Provider
      value={{
        selected,
        toggleSelection,
        deselectAll,
        selectByIds,
        deleteDataByViewId,
        setDeleteDataByViewId,
      }}
    >
      {children}
    </SelectionContext.Provider>
  );
};
